export default "__VITE_ASSET__CS1c21D2__"